import styled, { css } from 'styled-components';
import { colors } from 'app/shared/styles/_colors';

export const TabRow = styled.div`
  padding: 8px 0;
  width: 100%;
`;

type TabGroupProps = {
  maxWidth?: boolean;
};

export const TabGroup = styled.div<TabGroupProps>`
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  margin-left: auto;
  margin-right: auto;
  ${({ maxWidth }) =>
    maxWidth &&
    `
	    max-width: 380px;
	`}
`;

type TabItemProps = {
  active?: boolean;
};

export const TabItem = styled.button<TabItemProps>`
  line-height: 20px;
  border: 1px solid ${colors['$hpx-grey-100']};
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  padding: 8px;
  text-align: center;

  ${({ active }) =>
    !active &&
    css`
      &:hover {
        background-color: ${colors['$hpx-grey-100']};
      }

      &:active {
        background-color: ${colors['$hpx-grey-400']};
      }
    `}

  &:first-child {
    border-right: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:not(:first-child):not(:last-child) {
    border-left: 1px solid ${colors['$hpx-grey-100']};
    border-right: 0;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-right: 1px solid ${colors['$hpx-grey-100']};
  }

  ${({ active }) =>
    active &&
    css`
      background-color: ${colors['$hpx-teal-500']};
      color: ${colors['$hpx-white']};
      cursor: inherit;
      font-weight: bold;
    `};
`;
